import { EmployeeSignupState } from 'core/application/employeeSignup/employeeSignupState'
import familyStatusApi from 'core/application/employeeSignup/familyStatus'
import personalDetailsApi from 'core/application/employeeSignup/personalDetails'
import nonEEFamilyStatusApi from 'core/application/nonEligibleEmployeeSignup/nonEEFamilyStatus'
import nonEEPersonalDetailsApi from 'core/application/nonEligibleEmployeeSignup/nonEEPersonalDetails'

import FamilyStatus, { FamilyStatusProps } from '../common/familyStatus'
import LegalDocuments, { LegalDocumentsProps } from '../common/legalDocuments'
import { NavItemProps } from '../common/models'
import PersonalDetails, { PersonalDetailsProps } from '../common/personalDetails'

export enum EligibleEmployeeSignupStep {
  PersonalDetails = 'ichra-personal-details',
  FamilyStatus = 'ichra-family-status',
  LegalDocuments = 'ichra-legal-documents',
}

export enum NonEligibleEmployeeSignupStep {
  PersonalDetails = 'ichra-non-ee-personal-details',
  FamilyStatus = 'ichra-non-ee-family-status',
}

export const EENavItemsMapping: NavItemProps[] = [
  {
    key: EligibleEmployeeSignupStep.PersonalDetails,
    component: PersonalDetails,
    nextButtonTooltip: '',
    mapState: (employeeSignupState: EmployeeSignupState | undefined): PersonalDetailsProps => {
      return {
        personalDetailValues: {
          personalEmail: employeeSignupState ? employeeSignupState.personalEmail : null,
          phoneNumber: employeeSignupState ? employeeSignupState.phoneNumber : null,
        },
        next: true,
        submitHandler: (values) => personalDetailsApi(values),
        numberOfQuestions: 3,
        currentQuestion: 1,
      }
    },
    icon: 'user',
  },
  {
    key: EligibleEmployeeSignupStep.FamilyStatus,
    component: FamilyStatus,
    nextButtonTooltip: '',
    mapState: (employeeSignupState: EmployeeSignupState | undefined): FamilyStatusProps => {
      return {
        familyStatusValues: {
          familyStatusId: employeeSignupState ? employeeSignupState.familyStatusId : null,
        },
        familyStatusApi: familyStatusApi,
        numberOfQuestions: 3,
        currentQuestion: 2,
        finish: false,
      }
    },
    icon: 'usergroup-add',
  },
  {
    key: EligibleEmployeeSignupStep.LegalDocuments,
    component: LegalDocuments,
    nextButtonTooltip: '',
    mapState: (): LegalDocumentsProps => {
      return {
        numberOfQuestions: 3,
        currentQuestion: 3,
        title: 'About ICHRA',
        productQuestion: 'What is ICHRA?',
      }
    },
    icon: 'file-text',
  },
]

export const NonEENavItemsMapping: NavItemProps[] = [
  {
    key: NonEligibleEmployeeSignupStep.PersonalDetails,
    component: PersonalDetails,
    nextButtonTooltip: '',
    mapState: (employeeSignupState: EmployeeSignupState | undefined): PersonalDetailsProps => {
      return {
        personalDetailValues: {
          personalEmail: employeeSignupState ? employeeSignupState.personalEmail : null,
          phoneNumber: employeeSignupState ? employeeSignupState.phoneNumber : null,
        },
        submitHandler: (values) => nonEEPersonalDetailsApi(values),
        numberOfQuestions: 2,
        currentQuestion: 1,
        next: true,
      }
    },
    icon: 'user',
  },
  {
    key: NonEligibleEmployeeSignupStep.FamilyStatus,
    component: FamilyStatus,
    nextButtonTooltip: '',
    mapState: (employeeSignupState: EmployeeSignupState | undefined): FamilyStatusProps => {
      return {
        familyStatusValues: {
          familyStatusId: employeeSignupState ? employeeSignupState.familyStatusId : null,
        },
        familyStatusApi: nonEEFamilyStatusApi,
        numberOfQuestions: 2,
        currentQuestion: 2,
        finish: true,
      }
    },
    icon: 'usergroup-add',
  },
]
